import {
  ApartmentOutlined,
  BankOutlined,
  BarcodeOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  GiftOutlined,
  HeartOutlined,
  HomeOutlined,
  IdcardOutlined,
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
  SafetyOutlined,
  SolutionOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Alert, Button, Col, Modal, Row, Select, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import {
  clearUser,
  loadSingleStaff,
} from "../../redux/rtk/features/user/userSlice";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

import EmployeeDesignation from "../UI/EmployeeDesignation";
import EmployeeTimeline from "../UI/EmployeeTimeline";
import DesignationEditPopup from "../UI/PopUp/DesignationEditPopup";
import EducaitonEditPopup from "../UI/PopUp/EducaitonEditPopup";
import ProfileEditPopup from "../UI/PopUp/ProfileEditPopup";

import EmployeeSalary from "../UI/EmployeeSalary";
import SalaryEditPopup from "../UI/PopUp/SalaryEditPopup";

import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import EmployeeAward from "../UI/EmployeeAward";
import AddressEditPopup from "../UI/PopUp/addressEditPopup";
import AwardHistoryEditPopup from "../UI/PopUp/AwardHistoryEditPopup";
import BankDetailPopup from "../UI/PopUp/bankDetailPopup";
import ContactEditPopup from "../UI/PopUp/contactEditPoppup";
import EmployeeEditPopup from "../UI/PopUp/employeeEdit";
import { loadSalaryByUserId } from "../../redux/rtk/features/salary/salarySlice";
dayjs.extend(weekday);
dayjs.extend(localeData);

//PopUp

const DetailStaff = () => {
  const { id } = useParams();
  let navigate = useNavigate();

  //dispatch
  const dispatch = useDispatch();
  const user = useSelector((state) => state.users.user);
  const error = useSelector((state) => state.users.error);
  const designation = useSelector((state) => state.designations.list);
  const salaryHistory = useSelector((state) => state.salaryHistory.list);
  console.log("salaryHistory", salaryHistory);
  

  const { Option } = Select;
  const loginId = getUserFromToken();
  const [isModalVisible, setIsModalVisible] = useState(false);

  console.log(designation, "designation");
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onNavigateToDeletePage = () => {
    navigate("/admin/ProfileDelete");
  };
  const navigateToResetPassword = () => {
    navigate("/admin/resetPassword");
  };

  // Delete Supplier PopUp
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  useEffect(() => {
    dispatch(loadSingleStaff(id));
    return () => {
      dispatch(clearUser());
    };
  }, [id]);

  useEffect(() => {
    dispatch(loadAllDesignation());
	dispatch(loadSalaryByUserId(id));
  }, [dispatch]);

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  return (
    <div>
      <UserPrivateComponent permission={"readSingle-user"}>
        <PageTitle title=" Back  " />

        {/* Action Buttons */}
        {/* <div className="flex justify-center py-4 px-2 mt-5 mr-2"> */}
        {loginId === user?.id && (
          <>
            <Button
              type="primary"
              onClick={() => setIsModalVisible(true)}
              className="ml-4 mb-4 mt-2"
            >
              Manage Account
            </Button>
            <Modal
              title="Account Actions"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
            >
              <Space
                direction="vertical"
                size="middle"
                style={{ width: "100%" }}
              >
                <Button
                  type="default"
                  icon={<LockOutlined />}
                  onClick={navigateToResetPassword}
                  block
                >
                  Reset Password
                </Button>
                <Button
                  type="primary"
                  danger
                  icon={<UserDeleteOutlined />}
                  onClick={onNavigateToDeletePage}
                  block
                >
                  Delete my profile
                </Button>
              </Space>
            </Modal>
          </>
        )}

        {user ? (
          <div className="">
            <section>
              <div className="flex justify-between ant-card rounded h-auto mr-8">
                {/* Profile Card */}

                {/* <div className='flex justify-start'> */}
                {/*	<img
										src='https://cdn-icons-png.flaticon.com/512/2202/2202112.png'
										alt='profile'
										className='rounded-full h-40 w-40 m-5'
									/> */}
                {/* <div class='flex justify-center py-8 px-4 mt-4 ml-4'>
										<div class='flex flex-col items-around'>
											<h1 class='text-2xl font-bold txt-color-2 mb-1'>
												{(user?.firstName + " " + user?.lastName).toUpperCase()}
											</h1>
											<h2 class='text-base font-medium txt-color-secondary mb-1'>
												{user?.designationHistory[0]?.designation?.name ||
													"No Designation"}
											</h2>
											<h3 class='text-base font-medium txt-color-secondary'>
												{user?.department?.name || "No Department"}
											</h3>
											<h3 class='text-base font-medium txt-color-secondary'>
												{user?.employeeId || "No Employee ID"}
											</h3>

										</div>
									</div>
								</div> */}

                {/* Leave Status */}
                {/* <div className=''>
									<div className='flex justify-center py-8 px-4 mt-4'>
										<div className='flex flex-col items-around'>
											<h1 className='text-2xl font-bold txt-color-2 mb-1'>
												Leave Status
											</h1>

											<h3 className='text-base font-medium txt-color-secondary'>
												Leaves :{" "}
												<span className='text-base font-medium txt-color-2'>
													Paid - {user?.leavePolicy?.paidLeaveCount ?? 0} | U.Paid -{" "}
													{user?.leavePolicy?.unpaidLeaveCount ?? 0}
												</span>
											</h3>
											<h3 className='text-base font-medium txt-color-secondary'>
												Taken :{" "}
												<span className='text-base font-medium txt-color-2'>
													Paid -{" "}
													{(user?.leavePolicy?.paidLeaveCount ?? 0) -
														(user?.leftPaidLeaveDays ?? 0)}{" "}
													| U.Paid -{" "}
													{(user?.leavePolicy?.unpaidLeaveCount ?? 0) -
														user?.leftUnpaidLeaveDays ?? 0}
												</span>
											</h3>
											<h3 className='text-base font-medium txt-color-secondary'>
												Balance :{" "}
												<span className='text-base font-medium txt-color-2'>
													Paid - {user?.leftPaidLeaveDays} | U.Paid -{" "}
													{user?.leftUnpaidLeaveDays}
												</span>
											</h3>
										</div>
									</div>
								</div> */}

                {/*Clock In and Out Time*/}

                {/* <div className='flex justify-center py-8 px-4 mt-4'>
									<div className='flex flex-col items-around'>
										<h1 className='text-2xl font-bold txt-color-2 mb-1'>
											Clock In  Out
										</h1>

										<h3 className='text-base font-medium txt-color-secondary'>
											In Time :{" "}
											<span className='text-base font-medium txt-color-2'>
												{dayjs(user?.attendance.inTime).format("hh:mm A")}
											</span>
										</h3>

										<h3 className='text-base font-medium txt-color-secondary'>
											Out Time :{" "}
											<span className='text-base font-medium txt-color-2'>
												{dayjs(user?.attendance.outTime).format("hh:mm A")}
											</span>
										</h3>
									</div>
								</div> */}

                {/* Action Buttons */}

                {/* <div className=''>
									<div className='flex justify-center py-8 px-4 mt-10 mr-4'>
										<UserPrivateComponent permission='update-user'>
											<button className='mr-2 mt-2'>
												{user && <ProfileEditPopup data={user} />}
											</button>
										</UserPrivateComponent>

									</div>
								</div> */}
              </div>
            </section>
            <Row
              className="mt-5"
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
                xl: 32,
              }}
            >
              {user && (
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={11}
                  xl={11}
                  className="new-card rounded h-auto m-2"
                >
                  <div className="flex justify-between items-center">
                    <ProfileCardText className="text-start">
                      Personal Information
                    </ProfileCardText>
                    <UserPrivateComponent permission={"update-user"}>
                      <ProfileEditPopup userId={user?.id} user={user} />
                    </UserPrivateComponent>
                  </div>

                  <Hr />

                  <div className="m-5">
                    <ul className="space-y-4">
                      <li className="flex items-center">
                        <UserOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Full Name:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {/* {user?.firstName || "Not Available"} */}
                          {(
                            user?.firstName +
                            " " +
                            user?.lastName
                          ).toUpperCase() || "Not Available"}
                        </p>
                      </li>

                      {/* Father's Name */}
                      <li className="flex items-center">
                        <UserOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Father's Name:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.fatherName || "Not Available"}
                        </p>
                      </li>

                      {/* Email */}
                      <li className="flex items-center">
                        <MailOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">Email:</span>
                        <p className="txt-color-secondary ml-2">
                          {user?.email || "Not Available"}
                        </p>
                      </li>

                      {/* Blood Group */}
                      <li className="flex items-center">
                        <ThunderboltOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Blood Group:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.bloodGroup || "Not Available"}
                        </p>
                      </li>

                      {/* Birth Anniversary */}
                      <li className="flex items-center">
                        <GiftOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Birth Anniversary:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.birthAnniversary
                            ? dayjs(user?.birthAnniversary).format("DD/MM/YYYY")
                            : "Not Available"}
                        </p>
                      </li>

                      {/* Birthday */}
                      <li className="flex items-center">
                        <CalendarOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Birthday:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.birthdate
                            ? dayjs(user?.birthdate).format("DD/MM/YYYY")
                            : "Not Available"}
                        </p>
                      </li>

                      {/* Marital Status */}
                      <li className="flex items-center">
                        <HeartOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Marital Status:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.maritalStatus ? "Married" : "Single"}
                        </p>
                      </li>

                      {/* Marriage Anniversary */}
                      <li className="flex items-center">
                        <CalendarOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Marriage Anniversary:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.marriageAnniversary
                            ? dayjs(user?.marriageAnniversary).format(
                                "DD/MM/YYYY"
                              )
                            : "Not Available"}
                        </p>
                      </li>

                      {/* Gender */}
                      <li className="flex items-center">
                        <UserOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">Gender:</span>
                        <p className="txt-color-secondary ml-2">
                          {user?.gender || "Not Available"}
                        </p>
                      </li>

                      {/* PAN */}
                      <li className="flex items-center">
                        <IdcardOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">PAN:</span>
                        <p className="txt-color-secondary ml-2">
                          {user?.pan || "Not Available"}
                        </p>
                      </li>

                      {/* Aadhaar */}
                      <li className="flex items-center">
                        <IdcardOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Aadhaar:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.aadhar || "Not Available"}
                        </p>
                      </li>
                    </ul>
                  </div>
                </Col>
              )}
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="new-card rounded h-auto m-2"
              >
                <div className="flex justify-between items-center">
                  <ProfileCardText className="text-start">
                    Contact Information
                  </ProfileCardText>
                  <UserPrivateComponent permission={"update-user"}>
                    <ContactEditPopup userId={user?.id} user={user} />
                  </UserPrivateComponent>
                </div>

                <Hr />
                <div className="m-5">
                  <ul className="space-y-4">
                    {/* Phone Number */}
                    <li className="flex items-center">
                      <PhoneOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Phone:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.phone || "No Phone"}
                      </p>
                    </li>

                    {/* Alternate Number */}
                    <li className="flex items-center">
                      <PhoneOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Alternate Number:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.alternateNumber || "No Alternate Number"}
                      </p>
                    </li>

                    {/* Emergency Contact Number */}
                    <li className="flex items-center">
                      <PhoneOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Emergency Contact:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.emergencyContactNumber || "No Emergency Contact"}
                      </p>
                    </li>
                    {/* Emergency Contact Number */}
                    <li className="flex items-center">
                      <UserOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Emergency Contact Person:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.contactPersonName || "No Emergency Contact"}
                      </p>
                    </li>

                    {/* Contact Person Relation */}
                    <li className="flex items-center">
                      <UserOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">
                        Contact Person Relation:
                      </span>
                      <p className="txt-color-secondary ml-2">
                        {user?.contactPersonRelation || "No Relation Provided"}
                      </p>
                    </li>
                  </ul>
                </div>
              </Col>
              {user.company_id && (
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={11}
                  xl={11}
                  className="new-card rounded h-auto m-2"
                >
                  <div className="flex justify-between items-center">
                    <ProfileCardText className="text-start">
                      Employee Information
                    </ProfileCardText>
                    <UserPrivateComponent permission={"update-user"}>
                      <EmployeeEditPopup userId={user?.id} user={user} />
                    </UserPrivateComponent>
                  </div>
                  <Hr />

                  <div className="m-5">
                    <ul className="space-y-4">
                      <li className="flex items-center">
                        <IdcardOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Employee ID:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.employeeId || "Not Available"}
                        </p>
                      </li>
                      <li className="flex items-center">
                        <IdcardOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Company Name:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.companyMaster?.company_name || "Not Available"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <MailOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Official Mail:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.officialMailId || "Not Available"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <CalendarOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Join Date:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.joinDate
                            ? dayjs(user?.joinDate).format("DD/MM/YYYY")
                            : "Not Available"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <SafetyOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">ESIC:</span>
                        <p className="txt-color-secondary ml-2">
                          {user?.esic || "Not Available"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <TeamOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Employment Status:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.employmentStatus?.name ||
                            "No Employment Status"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <ApartmentOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Department:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.department?.name || "No Department"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <UserOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Reporting Manager:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.reportingManager
                            ? `${user.reportingManager.firstName} ${user.reportingManager.lastName}`
                            : "Not Assigned"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <UserOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">Role:</span>
                        <p className="txt-color-secondary ml-2">
                          {user?.role?.name || "No Role"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <ClockCircleOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">Shift:</span>
                        {/* <p className='txt-color-secondary ml-2'>
												{user?.shift?.name || "No Shift"} (
												{dayjs(user?.shift?.startTime).format("HH:MM")} -{" "}
												{dayjs(user?.shift?.endTime).format("HH:MM")})
											</p> */}
                        <p className="txt-color-secondary ml-2">
                          {user?.shift?.name || "No Shift"} (
                          {dayjs.utc(user?.shift?.startTime).format("HH:mm")} -
                          {dayjs.utc(user?.shift?.endTime).format("HH:mm")})
                        </p>
                      </li>

                      <li className="flex items-center">
                        <CalendarOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Weekly Holiday:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.weeklyHoliday?.name || "Not Available"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <SolutionOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          PF Eligibility:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.pfEligiblity ? "Eligible" : "Not Eligible"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <BarcodeOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">UAN:</span>
                        <p className="txt-color-secondary ml-2">
                          {user?.uan || "Not Available"}
                        </p>
                      </li>

                      <li className="flex items-center">
                        <DollarOutlined
                          className="mr-3"
                          style={{ fontSize: "15px" }}
                        />
                        <span className="txt-color-2 font-medium">
                          Payment Type:
                        </span>
                        <p className="txt-color-secondary ml-2">
                          {user?.tbl_paymentType?.[0]?.paymentType ||
                            "Not Specified"}
                        </p>
                      </li>
                    </ul>
                  </div>
                </Col>
              )}

              <Col
                xs={24}
                sm={12}
                md={12}
                lg={11}
                xl={11}
                className="new-card rounded h-auto m-2"
              >
                {/* <ProfileCardText className='text-start'>Address Details</ProfileCardText> */}
                <div className="flex justify-between items-center">
                  <ProfileCardText className="text-start">
                    Address Details
                  </ProfileCardText>
                  <UserPrivateComponent permission={"update-user"}>
                    <AddressEditPopup userId={user?.id} user={user} />
                  </UserPrivateComponent>
                </div>
                <Hr />

                <div className="m-5">
                  <ul className="space-y-4">
                    {/* Current Address Heading */}
                    <li className="flex items-center">
                      <HomeOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-primary font-medium">
                        Current Address
                      </span>
                    </li>

                    {/* Current Address Fields */}
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Address:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.street || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">City:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.city || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">State:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.state || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Zip Code:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.zipCode || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Country:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.country || "Not Available"}
                      </p>
                    </li>

                    {/* Divider */}
                    <li>
                      <Hr />
                    </li>

                    {/* Permanent Address Heading */}
                    <li className="flex items-center">
                      <HomeOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-primary font-medium">
                        Permanent Address
                      </span>
                    </li>

                    {/* Permanent Address Fields */}
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Address:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.pAddress || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">City:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.pCity || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">State:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.pState || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Zip Code:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.pZipCode || "Not Available"}
                      </p>
                    </li>
                    <li className="flex items-center">
                      <EnvironmentOutlined
                        className="mr-3"
                        style={{ fontSize: "15px" }}
                      />
                      <span className="txt-color-2 font-medium">Country:</span>
                      <p className="txt-color-secondary ml-2">
                        {user?.pCountry || "Not Available"}
                      </p>
                    </li>
                  </ul>
                </div>
              </Col>
              {user.company_id && (
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={11}
                  xl={11}
                  className="new-card rounded h-auto m-2"
                >
                  <div className="flex justify-between">
                    <ProfileCardText className="text-start">
                      Designation History
                    </ProfileCardText>

                    <UserPrivateComponent
                      permission={"update-designationHistory"}
                    >
                      {user?.designationHistory && (
                        <DesignationEditPopup data={user?.designationHistory} />
                      )}
                    </UserPrivateComponent>
                  </div>
                  <Hr />
                  <div className="flex justify-start ml-10">
                    {user?.designationHistory?.length !== 0 ? (
                      <EmployeeDesignation list={user?.designationHistory} />
                    ) : (
                      <div className="mb-10">
                        <p className="text-center mt-3 mb-3">
                          No Designation History Found
                        </p>
                        <Alert
                          message="Not found , Click on edit button to add new"
                          type="info"
                          showIcon
                        />
                      </div>
                    )}
                  </div>
                </Col>
              )}
              {user.company_id && (
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={11}
                  xl={12}
                  className="new-card rounded h-auto m-2 "
                >
                  <div className="flex justify-between">
                    <ProfileCardText className="text-start">
                      Education History
                    </ProfileCardText>
                    <UserPrivateComponent permission={"update-education"}>
                      {user?.educations && (
                        <EducaitonEditPopup data={user?.educations} />
                      )}
                    </UserPrivateComponent>
                  </div>
                  <Hr />
                  <div className="flex justify-start ml-10">
                    {user?.educations?.length !== 0 ? (
                      <EmployeeTimeline list={user?.educations} />
                    ) : (
                      <div className="mb-10">
                        <p className="text-center mt-3 mb-3">
                          No Education History Found
                        </p>
                        <Alert
                          message="Not found , Click on edit button to add new"
                          type="info"
                          showIcon
                        />
                      </div>
                    )}
                  </div>
                </Col>
              )}
              {user.company_id && (
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={11}
                  xl={11}
                  className="new-card rounded h-auto m-2 "
                >
                  <div className="flex justify-between">
                    <ProfileCardText className="text-start">
                      Salary History
                    </ProfileCardText>
                    <UserPrivateComponent permission={"update-salaryHistory"}>
                      {salaryHistory && (
                        <SalaryEditPopup data={salaryHistory} />
                      )}
                    </UserPrivateComponent>
                  </div>
                  <Hr />
                  <div className="flex justify-start ml-10">
                    {salaryHistory?.length !== 0 ? (
                      <EmployeeSalary list={salaryHistory} />
                    ) : (
                      <div className="mb-10">
                        <p className="text-center mt-3 mb-3 ">
                          No Salary History Found
                        </p>
                        <Alert
                          message="Not found , Click on edit button to add new"
                          type="info"
                          showIcon
                        />
                      </div>
                    )}
                  </div>
                </Col>
              )}
              {/* Bank Details Section */}
              {user.company_id && (
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={11}
                  xl={11}
                  className="new-card rounded h-auto m-2"
                >
                  <div className="flex justify-between">
                    <ProfileCardText className="text-start">
                      Bank Details
                    </ProfileCardText>

                    <UserPrivateComponent permission="update-user">
                      <button className="mr-2 mt-2">
                        {/* Show BankDetailPopup regardless of whether bank details exist */}
                        <BankDetailPopup data={user?.bankDetails?.[0] || {}} />
                      </button>
                    </UserPrivateComponent>
                  </div>
                  <Hr />
                  <div className="m-5">
                    {user?.bankDetails && user.bankDetails.length > 0 ? (
                      <ul className="space-y-4">
                        <li className="flex items-center">
                          <BankOutlined
                            className="mr-3"
                            style={{ fontSize: "15px" }}
                          />
                          <span className="txt-color-2 font-medium">
                            Account Holder:
                          </span>
                          <p className="txt-color-secondary ml-2">
                            {user.bankDetails[0]?.accountHolderName || "N/A"}
                          </p>
                        </li>
                        <li className="flex items-center">
                          <BankOutlined
                            className="mr-3"
                            style={{ fontSize: "15px" }}
                          />
                          <span className="txt-color-2 font-medium">
                            Bank Name:
                          </span>
                          <p className="txt-color-secondary ml-2">
                            {user.bankDetails[0]?.bankName || "N/A"}
                          </p>
                        </li>
                        <li className="flex items-center">
                          <BankOutlined
                            className="mr-3"
                            style={{ fontSize: "15px" }}
                          />
                          <span className="txt-color-2 font-medium">
                            Account Number:
                          </span>
                          <p className="txt-color-secondary ml-2">
                            {user.bankDetails[0]?.accountNumber || "N/A"}
                          </p>
                        </li>
                        <li className="flex items-center">
                          <BankOutlined
                            className="mr-3"
                            style={{ fontSize: "15px" }}
                          />
                          <span className="txt-color-2 font-medium">
                            IFSC Code:
                          </span>
                          <p className="txt-color-secondary ml-2">
                            {user.bankDetails[0]?.IFSC_code || "N/A"}
                          </p>
                        </li>
                        <li className="flex items-center">
                          <BankOutlined
                            className="mr-3"
                            style={{ fontSize: "15px" }}
                          />
                          <span className="txt-color-2 font-medium">
                            Branch:
                          </span>
                          <p className="txt-color-secondary ml-2">
                            {user.bankDetails[0]?.branchName || "N/A"}
                          </p>
                        </li>
                      </ul>
                    ) : (
                      <div className="mb-10">
                        <p className="text-center mt-3 mb-3">
                          No Bank Details Found
                        </p>
                        <Alert
                          message="Not found, Click on edit button to add new"
                          type="info"
                          showIcon
                        />
                      </div>
                    )}
                  </div>
                </Col>
              )}
              {/* Documents Section */}
              {/* <Col
								xs={24}
								sm={12}
								md={12}
								lg={12}
								xl={12}
								className="new-card rounded h-auto m-2"
							> */}
              {/* <div className="flex justify-between">
									<ProfileCardText className="text-start">
										Update Document
									</ProfileCardText>
									<UserPrivateComponent permission={"update-user"}>
										<button onClick={showModal} aria-label="Edit Document Details">
											<BtnEditSvg size={30} />
										</button>
										<Modal
											title="Update Document Details"
											visible={isModalVisible}
											onCancel={handleCancel}
											footer={null}
											width={800}
										>
											<DocumentEditPopup />
										</Modal>
									</UserPrivateComponent>
								</div> */}
              {/* <Hr />
								<div className="m-5">
									{user?.documents && user.documents.length > 0 ? (
										<ul className="space-y-4">
											{user.documents.map((doc, index) => (
												<li key={doc.id} className="flex items-center">
													<FileOutlined className="mr-3" style={{ fontSize: "15px" }} />
													<p className="txt-color-secondary ml-2">
														{doc.documentType}
													</p>
													{doc.uploadFile && (
														<div className="ml-2">
															
															{doc.uploadFile.endsWith(".pdf") ? (
																<a
																	href={`http://93.127.198.13:2002/document-proof/${doc.uploadFile}`}
																	target="_blank"
																	rel="noopener noreferrer"
																	className="text-blue-500"
																>
																	View Document
																</a>
															) : (
																
																<img
																	src={`http://93.127.198.13:2002/document-proof/${doc.uploadFile}`}
																	alt={doc.documentType}
																	style={{ width: 100, height: 100, objectFit: "cover" }}
																/>
															)}
														</div>
													)}
												</li>
											))}
										</ul>
									) : (
										<div className="mb-10">
											<p className="text-center mt-3 mb-3">No Documents Found</p>
											<Alert
												message="Not found, Click on edit button to add new"
												type="info"
												showIcon
											/>
										</div>
									)}
								</div>
							</Col> */}

              {user.company_id && (
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={11}
                  xl={12}
                  className="new-card rounded h-auto m-2 "
                >
                  <div className="flex justify-between">
                    <ProfileCardText className="text-start">
                      Award History
                    </ProfileCardText>

                    <UserPrivateComponent permission={"update-awardHistory"}>
                      {user?.awardHistory && (
                        <AwardHistoryEditPopup data={user?.awardHistory} />
                      )}
                    </UserPrivateComponent>
                  </div>
                  <Hr />
                  <div className="flex justify-start ml-10">
                    {user?.awardHistory?.length !== 0 ? (
                      <EmployeeAward list={user?.awardHistory} />
                    ) : (
                      <div className="mb-10">
                        <p className="text-center mt-3 mb-3 ">
                          No Award History Found
                        </p>
                        <Alert
                          message="Not found , Click on edit button to add new"
                          type="info"
                          showIcon
                        />
                      </div>
                    )}
                  </div>
                </Col>
              )}
            </Row>
          </div>
        ) : (
          <div className="mt-10">
            <Loader />
            {error && <p className="text-center mt-3 mb-3">No Data Found</p>}
          </div>
        )}
      </UserPrivateComponent>
    </div>
  );
};

const ProfileCardText = tw.div`
txt-color-2
text-xl
 text-center
  mt-5 `;

const Hr = tw.hr`
mt-3
mb-3
new-hr

`;

const Information = tw.div`
m-5
`;

export default DetailStaff;
